var breakpoints = {
  desktop: 1024,
  // min
  tablet: 1023,
  mobile: 767
};
export { breakpoints };